import React, { Component } from 'react'
import { Scrollama, Step } from 'react-scrollama'
import { Tooltip, Icon } from 'antd';

import ConsumptionEvolution from '../charts/ConsumptionEvolution/ConsumptionEvolutionComponent'

const styles = {
  main: {
    //padding: '70vh 2vw',
    display: 'flex',
    fontFamily: 'Open Sans',
    justifyContent: 'space-between',
    position: 'relative',
  },
  /*test: {
    padding: 35,
    backgroundImage:
      `linear-gradient(to bottom,
        rgba(240, 255, 40, 1) 0%,
        rgba(240, 255, 40, 1) 100%),
      linear-gradient(to bottom,
        rgba(240, 40, 40, 1) 0%,
        rgba(240, 40, 40, 1) 100%)`,
    backgroundClip: 'content-box, padding-box',
  },*/
  btnContainer: {
    position: 'fixed',
  },
  btn: {
    padding: '8px 10px',
    fontSize: '14px',
    margin: '10px',
    fontFamily: 'Open Sans',
  },
  graphic: {
    position: 'sticky',
    top: '0',
    marginLeft: '35%',
    width: '65%',
    paddingTop: '10vh',
    height: '80vh'
  },
  scroller: {
    pointerEvents: 'none',
    zIndex: 100,
    flexBasis: '35%',
  },
  step: {
    fontFamily: 'tex-gyre-schola', 
    fontSize: 18,
    lineHeight: '1.2',
    color: 'black',
    margin: '2rem 2rem 2rem 2rem',
    textShadow: '-1px -1px 0 white, 1px -1px 0 white, -1px 1px 0 white, 1px 1px 0 white',
    paddingTop: 200,
    paddingBottom: 200,
    //border: '1px solid #333',
    //pointerEvents: 'none',
  },
  p: {
    fontSize: 35, 
    fontFamily: 'career', 
    borderLeftWidth: '5px',
    borderLeftColor: '#e2e2e2',
    borderLeftStyle: 'solid',
    padding: '16px',
    backgroundColor: '#ffffffc7'
  },
  quoted: {
    borderLeftWidth: '5px',
    borderLeftColor: '#e2e2e2',
    borderLeftStyle: 'solid',
    paddingLeft: '16px',
    backgroundColor: '#ffffffc7'
  }
};

export default class GlobalSituation extends Component {
  constructor(props) {
    super(props);
    this.state = { step: 0, width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  onStepEnter = ({ element, data, direction }) => {
    //element.style.backgroundColor = 'lightgoldenrodyellow';
    this.setState({ step: data, direction });
  };

  onStepExit = ({ element, data, direction }) => {
    if(this.state.step === 1 && direction === 'up' ) this.setState({ step: 0, direction });
    //element.style.backgroundColor = '#fff';
  };

  render() {
    const { step, direction, width, height } = this.state;
    return (
      <div>
        <div style={styles.main}>
          <div style={{ ...styles.scroller, flexBasis: width < 900 ? '100%' : '35%' }}>
            <Scrollama
              offset={0.33}
              onStepEnter={this.onStepEnter}
              onStepExit={this.onStepExit}
              //debug
            >
              <Step data={1}>
                <div style={{...styles.step, minHeight: '80vh' }}>
                  <div style={styles.p}>
                    In the <span style={{borderBottom: '5px solid grey'}}>USA</span>, overdose on prescription.
                  </div>
                    <div style={{...styles.quoted, paddingBottom: 16 }}>
                      Opioid use, expressed as <span style={{pointerEvents: 'auto'}}><Tooltip overlayStyle={{ width: 500}} title={<div style={{wordBreak: 'normal'}}>For Defined Daily Dose, "a measure given by the OMS to compare molecules together", explains Christine Lys, anesthesiologist and doctor-inspector general at INAMI. Or the theoretical average dose per day for a drug used in its main indication for an adult. For example, "365 S-DDD" means a patient treated with the drug every day for one year.</div>} placement="bottom"><span><span style={{ fontWeight: 900}}>S-DDD</span> <Icon type="question-circle" theme="twoTone" /></span></Tooltip></span>, has increased significantly in the past 20 years.</div>
                  <div style={{...styles.quoted, paddingBottom: 16 }}>Details and source: The visualization here shows the consumption of the main opioid analgesics (codeine, fentanyl, hydrocodone, hydromorphone, morphine and oxycodone). <span style={{pointerEvents: 'auto'}}><a target="_blank" rel="noopener noreferrer" href="https://www.incb.org/documents/Narcotic-Drugs/Technical-Publications/2018/INCB-Narcotics_Drugs_Technical_Publication_2018.pdf">«Narcotic Drugs. Estimated World Requirements for 2019. Statistics for 2017. »</a></span> International Narcotics Control Board, United Nations, Vienna, 2019</div>
                </div>
              </Step>
              <Step data={2}>
                <div style={{...styles.step, height: '80vh' }}>
                  <div style={styles.p}>
                    <span style={{borderBottom: '5px solid #e91e63'}}>Europe</span> consumption is also growing.
                  </div>
                  <h4 style={{...styles.quoted, paddingBottom: 16 }}>Average consumption of opioids in western and central Europe is growing steadily, but significantly less than in the United States.</h4>
                </div>
              </Step>
              <Step data={3}>
                <div style={{...styles.step, height: '120vh' }}>
                  <div style={styles.p}>
                    USA & Europe, same evolution: <Icon type="close"/> <span style={{marginTop: -10}}>4</span>
                  </div>
                  <h4 style={{...styles.quoted, paddingBottom: 16 }}>Over the past two decades, average consumption in Europe and in the US has increased in a similar fashion, quadrupling in 20 years.</h4>
                </div>
              </Step>
            </Scrollama>
          </div>
          <div style={{ position: 'absolute', top: 0, bottom: 0, width: '100%'}}>
            {/*<div style={styles.graphic}>*/}
            <div className="graphic" style={{ 
              marginLeft: width < 900 ? '0%' : '35%', 
              width: width < 900 ? '100%' : '65%',
              paddingTop: width < 900 ? '20vh' : '10vh',
              height: width < 900 ? '50vh' : '80vh',
              }}>
              {/*<div>Step: {step} – Direction: {direction} </div>*/}
              {height && <ConsumptionEvolution step={step} direction={direction} />}
            </div>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/GlobalSituation/GlobalSituation.js